import { SkillMapViewHeader } from "./skill-map-view-header"

export function TradeRowsWithHeader({ children }) {
    return (
        <>
            <SkillMapViewHeader />
            {children}
        </>
    )
}
